// Returns the browser's local calendar date as YYYY-MM-DD (avoids UTC-shift issues from toISOString)
export const getLocalDateString = (d = new Date()) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const parseTime = (timeStr) => {
    if (!timeStr) return null;
    const match = timeStr.match(/(\d{1,2})[:.](\d{2})\s*(am|pm)/i);
    if (!match) return null;
    let hour = parseInt(match[1]);
    const minute = parseInt(match[2]);
    const period = match[3].toLowerCase();
    if (period === 'pm' && hour !== 12) hour += 12;
    if (period === 'am' && hour === 12) hour = 0;
    return hour * 60 + minute;
};

export const generateTimeSlots = (clinic) => {
    if (!clinic || !clinic.working_hours) return [];
    const slots = [];
    const workingHours = clinic.working_hours.replace(/[–—]/g, '-');
    const timeRanges = workingHours.split('&').map(r => r.trim());
    timeRanges.forEach(range => {
        const [startTime, endTime] = range.split('-').map(t => t.trim());
        const startMinutes = parseTime(startTime);
        const endMinutes = parseTime(endTime);
        if (startMinutes !== null && endMinutes !== null && startMinutes < endMinutes) {
            for (let minutes = startMinutes; minutes < endMinutes; minutes += 15) {
                const hour = Math.floor(minutes / 60);
                const min = minutes % 60;
                let displayHour = hour;
                let period = 'AM';
                if (hour >= 12) { period = 'PM'; if (hour > 12) displayHour = hour - 12; }
                if (hour === 0) displayHour = 12;
                slots.push(`${displayHour}:${min === 0 ? '00' : min.toString().padStart(2, '0')} ${period}`);
            }
        }
    });
    return slots;
};

// clinic must have { working_hours, sunday_hours } shape
export const getAvailableTimeSlots = (clinic, appointmentDate) => {
    if (!clinic || !appointmentDate) return [];
    const dayOfWeek = new Date(appointmentDate).getDay(); // 0 = Sunday
    const slots = dayOfWeek === 0
        ? (clinic.sunday_hours && clinic.sunday_hours !== 'Closed'
            ? generateTimeSlots({ working_hours: clinic.sunday_hours })
            : [])
        : generateTimeSlots(clinic);

    // Require at least a 2-hour lead time for slots booked on today's date
    if (appointmentDate === getLocalDateString()) {
        const now = new Date();
        const cutoff = now.getHours() * 60 + now.getMinutes() + 120;
        return slots.filter(t => parseTime(t) >= cutoff);
    }
    return slots;
};
